import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createCsvMockEndpoint } from '@/mocks/create-csv-mock-endpoint';
import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { AccountIndexDownloadResponse } from '@/repositories/generated';

const response: AccountIndexDownloadResponse = {
  presignedUrl: createCsvMockEndpoint([
    ['アカウントID', 'アクワイアラID', 'アクワイアラ名', 'イシュアID', 'イシュア名', 'ウォレットサービスID', 'ウォレットサービス名', '企業ID', '企業名', '店舗ID', '店舗名', 'ログインID', 'ステータス', 'ログインロック状態', '権限', '氏名', 'メールアドレス', '最終パスワード変更日時', '削除日時', '未ログインロック予定日時', '登録者アカウント名', '登録者アカウントID', '登録日時', '備考'],
  ]),
};

export const accountDownload = http.get(
  createMockEndpoint('/account/download'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
